import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'antd';
import SiderAction from '../SiderAction';

import { Container } from './ResetSettings.styles';
import { colors } from '../../utils/variables.styles';
import withTranslation from "../WithTranslation/WithTranslation";
import {RedoOutlined} from "@ant-design/icons";

class ResetSettings extends React.Component {

  static defaultProps = {
    translationsData: null,
  }
  showDeleteConfirm = () => {
    Modal.confirm({
      title: this.props.t('are_you_sure'),
      content: this.props.t('garage_model_restored'),
      okText: this.props.t('yes'),
      okType: 'danger',
      cancelText: this.props.t('no'),
      onOk: this.props.resetConstruction
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div style={{ color: colors.primaryFontColor }}>
        <Container collapsed={this.props.collapsed}>
          <SiderAction
            icon={<RedoOutlined />}
            collapsed={this.props.collapsed}
            onClick={this.showDeleteConfirm}
            pointer
            bottom
          >
            {this.props.translationsData.clear || 'clear'}
          </SiderAction>
        </Container>
      </div>
    );
  }
}

ResetSettings.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  resetConstruction: PropTypes.func.isRequired
};

export default withTranslation(ResetSettings);
